import { ChangeDetectionStrategy, Component, inject, input, OnInit, output } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';

import { atLeastOneValidator, DialogRef } from '@hglobal/common';
import { FormType, TeamAward } from '@pt/models';
import { GoogleAnalyticsService } from '@pt/services';

export interface TeamMemberAwardsForm {
  awardId: number;
  colleagueId: number;
  comment: string;
}

@Component({
  standalone: false,
  selector: 'pu-awards-form',
  templateUrl: './awards-form.component.html',
  styleUrls: ['./awards-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwardsFormComponent implements OnInit {
  readonly #googleAnalyticsService = inject(GoogleAnalyticsService);

  teamAwards = input<TeamAward[]>();
  openedFromPersonalInfo = input<boolean>();

  closeModal = output<void>();

  awardsForm: FormArray<FormType<TeamMemberAwardsForm>>;
  commentsState: Record<string, any> = {};

  constructor(private _fb: FormBuilder, private _dialogRef: DialogRef) {
  }

  ngOnInit() {
    this.awardsForm = this._initAwardsForm();
  }

  toggleComment(index: number, colleagueId: number | undefined) {
    this.commentsState[index] = !this.commentsState[index];

    if (this.commentsState[index] && this.openedFromPersonalInfo()) {
      this.#googleAnalyticsService.pushCustomEvent('team_bonuses', 'add_comment', {
        element_name: 'reward',
        id: colleagueId,
      });
    }
  }

  send(): void {
    this._dialogRef.close({
      type: 'awards',
      payload: this.awardsForm.value.filter(value => value.awardId),
      openedFromPersonalInfo: this.openedFromPersonalInfo(),
    });
  }

  close(): void {
    this.closeModal.emit();
  }

  onSelectClick(colleagueId: number | undefined): void {
    if (this.openedFromPersonalInfo()) {
      this.#googleAnalyticsService.pushCustomEvent('team_bonuses', 'select_award', {
        element_name: 'reward',
        id: colleagueId,
      });
    }
  }

  private _initAwardsForm(): FormArray<FormType<TeamMemberAwardsForm>> {
    return new FormArray<FormType<TeamMemberAwardsForm>>(
      this.teamAwards().map(({ colleague }) => this._fb.group<TeamMemberAwardsForm>({
        colleagueId: colleague.id,
        awardId: null,
        comment: '',
      })),
      atLeastOneValidator(control => control.controls.some(
        control => control.value.awardId !== null,
      )),
    );
  }
}
